import "bootstrap/dist/css/bootstrap.min.css"
import "prismjs/themes/prism-tomorrow.css"
import "./src/global.css"

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) {
    return decodeURI(location.hash.slice(1))
  }

  if (location.action === "PUSH") {
    return [0, 0]
  }

  return true
}
